import { useEffect, useState } from "react";
import { getData } from "../utils/apiCalls";
import { svgs } from "../assets/svgs";
import { tracking } from "../utils/tracking";

export const PresenterCards = () => {
    const [innovators, setInnovators] = useState([])

    useEffect(() => {
        getData(`https://youngstartup.io/api/cwebsite/get_presenting_compnies`)
            .then(res => {
                setInnovators(res)
            })
    }, [])

    return (
        <div className='presenter-cards'>
            <h1>Top Innovators who’ll be presenting at the summit</h1>
            {innovators.length > 100 && <h2>Presenting Companies <span>({innovators.length})</span></h2>}
            {/* <a id='glowLink' className="btn" href='https://account.youngstartup.com' onClick={() => { tracking(368); }}>APPLY NOW {svgs.glow}</a> */}
            {innovators.map((innovator, idx) =>
                <div key={idx}>
                    <section>
                        {innovator.logo_url
                            ? <img src={innovator.logo_url} alt="logo" />
                            : <h1>{innovator.company}</h1>}
                    </section>
                    <section>
                        <p>{innovator.one_liner}</p>
                        <a href={innovator.website} target="_blank">{svgs.website}</a>
                        {innovator.featured_presenter?.firstname && <div>
                            {innovator.headshot_url && <img className="headshot" src={innovator.headshot_url} alt="headshot" />}
                            {innovator.featured_presenter &&
                                <div>
                                    <h3>{innovator.featured_presenter.firstname} {innovator.featured_presenter.lastname}, {innovator.featured_presenter.jobtitle}</h3>
                                    <h3>{innovator.company}</h3>
                                </div>}
                        </div>}
                    </section>
                </div>
            )}
        </div >
    )
}
